/**
 * Email validation regex aligned with the BE validation rule
 * Domain part: each label must start and end with alphanumeric, hyphens allowed in between.
 *   Blocks: leading/trailing dots or hyphens per label, consecutive dots.
 * Valid:   john@company.com, john@sub.company.com, john@company-name.com
 * Invalid: john@.company.com, john@company-.com, john@co..mp.com, john@-company.com
 */
export const EMAIL_VALIDATION_REGEX = /^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*$/;
